import api from './api';

const pedidoService = {
  // Obtener todos los pedidos
  getPedidos: async () => {
    try {
      const response = await api.get('/pedidos');
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Obtener pedido por ID
  getPedidoById: async (id) => {
    try {
      const response = await api.get(`/pedidos/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Actualizar pedido
  updatePedido: async (id, pedidoData) => {
    try {
      const response = await api.put(`/pedidos/${id}`, pedidoData);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Cambiar estado del pedido (sistema de semáforo)
  cambiarEstado: async (id, estado) => {
    try {
      const response = await api.put(`/pedidos/${id}/estado`, { estado });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Agregar notificación
  agregarNotificacion: async (id, mensaje, tipo = 'info') => {
    try {
      const response = await api.post(`/pedidos/${id}/notificacion`, {
        mensaje,
        tipo
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Obtener pedidos por sucursal
  getPedidosPorSucursal: async (sucursal) => {
    try {
      const response = await api.get(`/pedidos/sucursal/${sucursal}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Obtener pedidos por estado (para sistema de semáforo)
  getPedidosPorEstado: async (estado) => {
    try {
      const response = await api.get(`/pedidos/estado/${estado}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Cancelar pedido
  cancelarPedido: async (id) => {
    try {
      const response = await api.post(`/pedidos/${id}/cancelar`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Eliminar pedido cancelado
  eliminarPedidoCancelado: async (id) => {
    try {
      const response = await api.delete(`/pedidos/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Actualizar días límite
  actualizarDiasLimite: async (id, diasLimite) => {
    try {
      const response = await api.put(`/pedidos/${id}/dias-limite`, { diasLimite });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Finalizar pedido
  finalizarPedido: async (id) => {
    try {
      const response = await api.put(`/pedidos/${id}/finalizar`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Registrar pago parcial
  registrarPago: async (id, pagoData) => {
    try {
      const response = await api.post(`/pedidos/${id}/pagos`, pagoData);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Descargar recibo de un pago
  descargarReciboPago: async (id, pagoId) => {
    try {
      const token = localStorage.getItem('token');
      const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

      const response = await fetch(`${API_URL}/pedidos/${id}/pagos/${pagoId}/pdf/recibo`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        let errorMessage = 'Error al generar recibo';
        try {
          const error = await response.json();
          errorMessage = error.message || errorMessage;
        } catch {
          errorMessage = `Error del servidor: ${response.status}`;
        }
        throw new Error(errorMessage);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `Recibo_${id.slice(-8).toUpperCase()}_${pagoId.slice(-6).toUpperCase()}.pdf`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      throw error;
    }
  }
};

export default pedidoService;